import React from "react";
import TranslationStudio from "../components/TranslationStudio";

const Translation = () => {
    return <TranslationStudio />;
}

export default Translation;